export default {
      id: "feuilles_actus-usage",
      viewBox: "0 0 235 370",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#feuilles_actus-usage",
      toString: function () {
        return this.url;
      }
    }